/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { MAGNETIC_TOKENS, css, utils } from '@appd/uik';
import { COUNTRIES } from './COUNTRIES';

export const TeamCell = ({ country = 'France' }) => {
  const code = utils.maybeGet(COUNTRIES, country);

  return (
    <div
      className={css({
        display: 'flex',
        gap: MAGNETIC_TOKENS.SPACING[1],
        alignItems: 'center',
        font: MAGNETIC_TOKENS.TYPOGRAPHY.P3_DEFAULT,
        ...MAGNETIC_TOKENS.TYPOGRAPHY.ELLIPSES.END,
      })}
    >
      {code && (
        <img
          className={css({ width: 18, height: 12 })}
          src={`https://flagcdn.com/w20/${code}.png`}
          srcSet={`https://flagcdn.com/w40/${code}.png 2x`}
          width="20"
          alt="Ukraine"
        />
      )}
      {country}
    </div>
  );
};
